export default {
  path: 'documentacao',
  component: () => import('@/components/pages/Documentation/Documentation'),
  meta: {
    title: 'Documentação'
  },
  children: [
    {
      path: '',
      name: 'documentation',
      component: () => import('@/components/pages/Documentation/Documentation')
    },
    {
      path: ':path',
      name: 'documentation-viewer',
      component: () => import('@/components/pages/Documentation/Documentation'),
      props: true
    }
  ]
}
